export default (client) => ({
  get(id) {
    return client.request({
      method: 'get',
      url: `/wooCategories/${id}`,
    });
  },
  find(filterParams) {
    return client.request({
      method: 'get',
      url: '/wooCategories',
      params: { ...filterParams },
    });
  },
  create(payload) {
    return client.request({
      method: 'post',
      url: '/wooCategories',
      data: payload,
    });
  },
  patch(id, payload) {
    return client.request({
      method: 'put',
      url: `/wooCategories/${id}`,
      data: payload,
    });
  },
});
